import { render, staticRenderFns } from "./CreateIndirectChannelPartnerPopUp.vue?vue&type=template&id=5c6080e2&scoped=true&"
import script from "./CreateIndirectChannelPartnerPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateIndirectChannelPartnerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateIndirectChannelPartnerPopUp.vue?vue&type=style&index=0&id=5c6080e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6080e2",
  null
  
)

export default component.exports